import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rk82ea6pnc: FaireBrandEntity = {
  token: "b_rk82ea6pnc",
  type: "brand",
  name: "Smeli",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c2dfdb4ffb4bffaf1a449f9a41e4d37e0d3f96c3d52c99ed4eb8aba7dc52849.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ebe19aadddd60db11c35c2537a140825f82008c268e01b7a09210967513c554.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c2dfdb4ffb4bffaf1a449f9a41e4d37e0d3f96c3d52c99ed4eb8aba7dc52849.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ebe19aadddd60db11c35c2537a140825f82008c268e01b7a09210967513c554.jpeg",
  location: "Columbus, USA",
  minimumOrderDollars: 28,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Smeli creates collectible candles where original artwork and fine fragrance become one. Inspired by gardens, orchards, changing seasons, and European landscapes, each candle begins as a hand-drawn illustration before becoming a layered fragrance. Poured in Ohio with clean fragrances and premium ingredients, every piece is designed to be displayed, gifted, and enjoyed long after the candle is lit.\n",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:42.640Z",
    importedBy: "entity-db-cli",
  },
};
